import Vue from 'vue';
import util from '../utils/index';

Vue.filter('removeLeftZero', function (value,fmt) {
    return util.removeLeftZero(value,fmt);
  });


// WEBPACK FOOTER //
// ./src/filters/math.js